'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.logCommit = logCommit;
exports.logControl = logControl;

var _reduxShip = require('redux-ship');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint-disable no-console */
function padTwoDigits(n) {
  return n < 10 ? '0' + String(n) : String(n);
}

function isoLocaleTimeString(date) {
  return padTwoDigits(date.getHours()) + ':' + padTwoDigits(date.getMinutes()) + ':' + padTwoDigits(date.getSeconds()) + '.' + (date.getMilliseconds() / 1000).toFixed(3).slice(2, 5);
}

var colors = {
  blue: '#03A9F4',
  green: '#4CAF50',
  grey: '#9E9E9E',
  inherit: 'inherit',
  lightPurle: '#795DA3',
  purle: '#800080'
};

function style(color) {
  return 'color: ' + color + '; font-weight: bold';
}

function logCommit(applyCommit) {
  return function (store) {
    return function (next) {
      return function (commit) {
        var previousState = store.getState();
        var result = next(commit);
        var nextState = store.getState();
        var now = new Date();
        var type = (typeof commit === 'undefined' ? 'undefined' : _typeof(commit)) === 'object' && commit !== null ? commit.type : '';
        console.group('%c commit @ ' + isoLocaleTimeString(now) + ' ' + String(type), style(colors.inherit));
        console.log('%c prev state', style(colors.grey), previousState);
        console.log('%c commit', style(colors.blue), commit);
        console.log('%c patch', style(colors.blue), applyCommit(previousState, commit));
        console.log('%c next state', style(colors.green), nextState);
        console.groupEnd();
        return result;
      };
    };
  };
}

function snapshotShape(snapshot) {
  return snapshot.map(function (snapshotItem) {
    return snapshotItem.type;
  });
}

function logControl(control) {
  return regeneratorRuntime.mark(function _callee(action) {
    var _console;

    var _ref, result, snapshot, now, type;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.delegateYield((0, _reduxShip.snap)(control(action)), 't0', 1);

          case 1:
            _ref = _context.t0;
            result = _ref.result;
            snapshot = _ref.snapshot;
            now = new Date();
            type = (typeof action === 'undefined' ? 'undefined' : _typeof(action)) === 'object' && action !== null ? action.type : '';

            console.group('%c control @ ' + isoLocaleTimeString(now) + ' ' + String(type), style(colors.inherit));
            console.log('%c action', style(colors.blue), action);
            (_console = console).log.apply(_console, ['%c shape', style(colors.lightPurle)].concat(_toConsumableArray(snapshotShape(snapshot))));
            console.log('%c snapshot', style(colors.purle), snapshot);

            console.groupCollapsed('%c json action snapshot', style(colors.grey));
            console.log(JSON.stringify({ action: action, snapshot: snapshot }));
            console.groupEnd();

            console.groupEnd();
            return _context.abrupt('return', result);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  });
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-ship-logger/dist/main/index.js
 ** module id = 514
 ** module chunks = 0
 **/